export const ActionSearchServices = {
	GET_SEARCH_SERVICES: "get_search_services",
	LOAD_GET_SEARCH_SERVICES: "load_get_search_services",
	RES_GET_SEARCH_SERVICES: "res_get_search_services",
	ERR_GET_SEARCH_SERVICES: "err_get_search_services",
	HYDRATE: "HYDRATE",
};

export function failureSearchServices(err) {

	return {
		type: ActionSearchServices.ERR_GET_SEARCH_SERVICES,
		err,
	};

}

export function loadSearchServices(params = {}) {

	return {
		type: ActionSearchServices.GET_SEARCH_SERVICES,
		...params,
	};

}

export function loadGetSearchServices(params = {}) {

	return {
		type: ActionSearchServices.LOAD_GET_SEARCH_SERVICES,
		...params,
	};

}

export function loadSearchServicesSuccess(data) {

	return {
		type: ActionSearchServices.RES_GET_SEARCH_SERVICES,
		data,
	};

}
